import {all} from 'redux-saga/effects';

import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';

import {
  fetchBookings as fetchBookingsAction,
  fetchSalesAgents as fetchSalesAgentsAction,
  fetchBookingTypes as fetchBookingTypesAction,
  fetchBookingOrganisations as fetchBookingOrganisationsAction,
  fetchBookingListFilters as fetchBookingListFiltersAction,
  fetchGoCardlessMandateStatuses as fetchGoCardlessMandateStatusesAction,
  fetchGoCardlessInvitationStatuses as fetchGoCardlessInvitationStatusesAction,
  createBooking as createBookingAction,
  createBookingExtension as createBookingExtensionAction
} from './';

import {
  fetchBookings,
  fetchSalesAgents,
  fetchBookingTypes,
  fetchBookingOrganisations,
  fetchBookingListFilters,
  fetchGoCardlessMandateStatuses,
  fetchGoCardlessInvitationStatuses,
  createBooking,
  createBookingExtension
} from 'sdk/bookings';

function* fetchBookingsSaga() {
  yield all([
    createFetchSagaLatest(fetchBookingsAction, fetchBookings),
    createFetchSagaLatest(fetchSalesAgentsAction, fetchSalesAgents),
    createFetchSagaLatest(fetchBookingTypesAction, fetchBookingTypes),
    createFetchSagaLatest(
      fetchBookingOrganisationsAction,
      fetchBookingOrganisations
    ),
    createFetchSagaLatest(
      fetchBookingListFiltersAction,
      fetchBookingListFilters
    ),
    createFetchSagaLatest(
      fetchGoCardlessMandateStatusesAction,
      fetchGoCardlessMandateStatuses
    ),
    createFetchSagaLatest(
      fetchGoCardlessInvitationStatusesAction,
      fetchGoCardlessInvitationStatuses
    ),
    createPostSagaLatest(createBookingAction, createBooking),
    createPostSagaLatest(createBookingExtensionAction, createBookingExtension)
  ]);
}

export default fetchBookingsSaga;
